import { useEffect } from 'react'

interface AddVariantIdOnPdpType {
  activeVariant: number;
  product: any;
  isMainProductLink: boolean;
}

function useAddVariantIdOnPdp(props: AddVariantIdOnPdpType) {
  const { product, activeVariant, isMainProductLink } = props;
 
  useEffect(() => {
    if(isMainProductLink===true){
      return;
    }
    if (product?.variants?.length) {
      if (history.pushState) {
        const newurl = window.location.protocol + "//" +
          window.location.host + window.location.pathname +
          `?vid=${product.variants[activeVariant]?.variant_id}`;

        if (product.variants[activeVariant]?.variant_id) {
          window.history.replaceState({ path: newurl }, '', newurl);
        }
      }
    }
  }, [activeVariant]);
}

export default useAddVariantIdOnPdp;
